/**
 * Single source of truth for the per-weight font-family names.
 */
export const FONT_FAMILY = {
  MODERAT_BLACK: 'Moderat-Black',
  MODERAT_BOLD: 'Moderat-Bold',
  MODERAT_MEDIUM: 'Moderat-Medium',
  MODERAT_REGULAR: 'Moderat-Regular',
  MODERAT_REGULAR_ITALIC: 'Moderat-Regular-Italic',
  MODERAT_LIGHT: 'Moderat-Light',
  PP_FRAGMENT_BLACK: 'PPFragment-GlareBlack',
  PP_FRAGMENT_BOLD: 'PPFragment-GlareBold',
  PP_FRAGMENT_MEDIUM: 'PPFragment-GlareMedium',
  PP_FRAGMENT_REGULAR: 'PPFragment-GlareRegular',
  PP_FRAGMENT_REGULAR_ITALIC: 'PPFragment-GlareRegularItalic',
  PP_FRAGMENT_LIGHT: 'PPFragment-GlareLight',
} as const
